/* Ported for Shopify by _build-theme.py.

   Asset paths are resolved through window.ESKUTA_ASSETS, published by
   snippets/asset-map.liquid. Do NOT reintroduce string-concatenated paths:
   Shopify asset URLs carry a ?v= cache-buster and live on a CDN, so a built
   path 404s — and it does so silently, looking like a slow image rather than a
   broken one. */
function eskutaAsset(name) {
  var map = window.ESKUTA_ASSETS || {};
  if (!map[name] && window.console) console.warn('[eskuta] asset not in map: ' + name);
  return map[name] || '';
}

/* Wireframe scaffolding only — none of this is production behaviour.
   One toggle: annotations on/off. */

(function () {
  var body = document.body;
  var LS_NOTES = 'wf-notes';

  /* ?notes=1 makes the state linkable — useful for sending a
     specific view to someone rather than "click the two toggles first". */
  var params = new URLSearchParams(location.search);

  function bind(id, cls, key, onLabel, offLabel, param, defaultOn) {
    var btn = document.getElementById(id);
    if (!btn) return;
    var stored = localStorage.getItem(key);
    var on = params.has(param)
      ? params.get(param) !== '0'
      : (stored === null ? !!defaultOn : stored === '1');
    apply(on);
    btn.addEventListener('click', function () {
      on = !on;
      localStorage.setItem(key, on ? '1' : '0');
      apply(on);
    });
    function apply(state) {
      body.classList.toggle(cls, state);
      btn.setAttribute('aria-pressed', String(state));
      btn.textContent = state ? onLabel : offLabel;
    }
  }
  bind('t-notes', 'show-notes', LS_NOTES, 'Annotations: on', 'Annotations: off', 'notes');
  /* Accent: off / gold / metallic. Three options, so a select rather than the
     boolean bind() above. Linkable as ?accent=gold, and it remembers — the
     point of it is comparing the three, which means carrying a choice from page
     to page rather than re-picking it on each one. */
  /* Dark mode, for testing. Same pattern as the accent: linkable (?theme=dark)
     and remembered, because judging it means carrying it across pages. */
  (function () {
    var sel = document.getElementById('t-theme');
    var stored = params.get('theme') || localStorage.getItem('wf-theme') || 'light';
    body.classList.toggle('dark', stored === 'dark');
    if (!sel) return;
    sel.value = stored;
    sel.addEventListener('change', function () {
      localStorage.setItem('wf-theme', sel.value);
      body.classList.toggle('dark', sel.value === 'dark');
    });
  }());

  (function () {
    var sel = document.getElementById('t-accent-mode');
    var MODES = ['off', 'gold', 'metal'];
    var stored = params.get('accent') || localStorage.getItem('wf-accent') || 'off';
    if (MODES.indexOf(stored) === -1) stored = 'off';
    if (!sel) return;
    apply(stored);
    sel.value = stored;
    sel.addEventListener('change', function () {
      localStorage.setItem('wf-accent', sel.value);
      apply(sel.value);
    });
    function apply(mode) {
      body.classList.toggle('accent-gold', mode === 'gold');
      body.classList.toggle('accent-metal', mode === 'metal');
    }
  }());
  /* ---- --nav-h ----------------------------------------------------------
     The sticky site nav is the only bar whose height CSS cannot know: the
     wireframe toolbar is a fixed --bar, but the nav grows with its own
     content and wraps differently on mobile. .solo-screen subtracts both to
     size itself to exactly one screen, so the value is measured here and
     published as a custom property. The CSS carries a desktop fallback, so a
     failure to run costs a few pixels rather than the layout. */
  (function () {
    var nav = document.querySelector('.site-nav');
    if (!nav) return;
    function measure() {
      document.documentElement.style.setProperty('--nav-h', nav.offsetHeight + 'px');
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(nav);
  }());

  /* Real assets, if they exist. Each <img> starts hidden with its wireframe
     placeholder showing; the swap happens only on a successful load, so a
     missing file leaves the placeholder in place rather than a broken icon.
     data-src is the WebP; data-src-alt is the original PNG/JPEG, tried once if
     the WebP 404s or fails to decode. */
  document.querySelectorAll('img[data-placeholder]').forEach(function (img) {
    var ph = document.querySelector(img.getAttribute('data-placeholder'));
    var triedAlt = false;

    img.addEventListener('load', function () {
      img.hidden = false;
      if (ph) ph.hidden = true;
      document.body.classList.add('has-' + img.getAttribute('data-asset'));
    });

    img.addEventListener('error', function () {
      var alt = img.getAttribute('data-src-alt');
      if (alt && !triedAlt) { triedAlt = true; img.src = alt; return; }
      img.hidden = true;                 /* placeholder simply stays visible */
    });

    /* Assigning src last means the handlers are attached before a cached
       image can fire load. */
    img.src = img.getAttribute('data-src');
  });

  /* ---- Fold snap -------------------------------------------------------
     If a scroll ENDS inside the hero it completes in whichever direction you
     were heading. Scrolling down, crossing 16% commits you to the consumer
     homepage. Scrolling back up, dropping under 25% returns you to the splash;
     above that you settle back down onto the homepage. You never park halfway.

     Deliberately not scroll-hijacking: nothing is intercepted or blocked mid
     gesture, it only acts once you have stopped, it never fires once you are
     past the fold, and it is off entirely under prefers-reduced-motion. You
     can always out-scroll it. */
  var hero = document.getElementById('splash');
  var consumerNav = document.querySelector('.site-nav');
  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');

  if (hero && consumerNav && !reduceMotion.matches) {
    var BAR = 0;               /* no wireframe toolbar in the theme */
    var DOWN = 0.16;           /* scrolling down: commit to the homepage here */
    var UP   = 0.45;           /* scrolling up: fall back to the splash here */
    var snapping = false;

    /* Direction matters, so the two thresholds differ. The gap between them is
       hysteresis: one threshold serving both directions makes the boundary
       sticky — stop near it and the smallest nudge flips you the other way.
       They are also deliberately lopsided. Going down is a commitment to the
       shop and should take a real swipe; coming back up is a correction, and
       corrections should be cheap. A high UP means a short scroll up reclaims
       the splash rather than dropping you back onto the homepage. */
    var lastY = window.scrollY;
    var dir = 1;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y !== lastY) dir = y > lastY ? 1 : -1;
      lastY = y;
    }, { passive: true });

    var onScrollEnd = function () {
      if (snapping) return;
      if (!hero.offsetHeight) return;

      var release = window.scrollY + consumerNav.getBoundingClientRect().top - BAR;
      var y = window.scrollY;

      /* Only act in the no-man's-land between the two resting points. */
      if (y <= 0 || y >= release - 2) return;

      var threshold = dir < 0 ? UP : DOWN;
      var target = y > release * threshold ? release : 0;
      if (Math.abs(target - y) < 2) return;

      /* The guard stops our own smooth scroll re-triggering this on its own
         scrollend. Released on actual settle rather than a guessed timeout,
         with a bail-out so a interrupted animation can't wedge it shut. */
      snapping = true;
      window.scrollTo({ top: target, behavior: 'smooth' });

      var settle;
      var bail = setTimeout(finish, 2000);

      function onMove() {
        clearTimeout(settle);
        settle = setTimeout(function () {
          if (Math.abs(window.scrollY - target) < 3) finish();
        }, 90);
      }
      function finish() {
        clearTimeout(bail);
        clearTimeout(settle);
        window.removeEventListener('scroll', onMove);
        snapping = false;
      }
      window.addEventListener('scroll', onMove, { passive: true });
    };

    if ('onscrollend' in window) {
      window.addEventListener('scrollend', onScrollEnd);
    } else {
      var idle;
      window.addEventListener('scroll', function () {
        clearTimeout(idle);
        idle = setTimeout(onScrollEnd, 120);
      }, { passive: true });
    }
  }

  /* ---- Demo form states -------------------------------------------------
     Submitting a wireframe form walks it through submitting → error → success
     so the three states can be seen in place rather than only on the states
     reference. First submit errors deliberately; second succeeds. */
  document.querySelectorAll('[data-demo-form]').forEach(function (form) {
    var attempts = 0;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.dataset.busy === '1') return;

      form.dataset.busy = '1';
      form.classList.add('is-busy');
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span class="spinner" aria-hidden="true"></span> Sending…';
      }
      var status = document.createElement('p');
      status.className = 'frm__status';
      status.setAttribute('role', 'status');
      status.textContent = 'Sending your request…';
      form.appendChild(status);

      setTimeout(function () {
        form.dataset.busy = '0';
        form.classList.remove('is-busy');
        status.remove();
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
        attempts++;
        if (attempts === 1) showError(); else showSuccess();
      }, 1100);
    });

    function showError() {
      form.querySelectorAll('.alert').forEach(function (a) { a.remove(); });
      var alert = document.createElement('div');
      alert.className = 'alert alert--error';
      alert.setAttribute('role', 'alert');
      alert.innerHTML = '<b>We couldn’t send that.</b><span>Check the highlighted fields. Nothing you typed has been lost.</span>';
      form.prepend(alert);

      /* Flag whichever required-looking fields are empty. */
      form.querySelectorAll('.fld').forEach(function (fld) {
        var input = fld.querySelector('input');
        if (!input || fld.querySelector('.fld__opt')) return;
        var bad = !input.value.trim();
        fld.classList.toggle('is-error', bad);
        input.setAttribute('aria-invalid', String(bad));
        var err = fld.querySelector('.fld__err');
        if (bad && !err) {
          err = document.createElement('span');
          err.className = 'fld__err';
          err.textContent = 'This one’s needed.';
          fld.appendChild(err);
        } else if (!bad && err) {
          err.remove();
        }
      });
      var firstBad = form.querySelector('.fld.is-error input');
      if (firstBad) firstBad.focus();
    }

    function showSuccess() {
      var box = document.createElement('div');
      box.className = 'success';
      box.setAttribute('role', 'status');
      box.innerHTML =
        '<div class="success__tick" aria-hidden="true">✓</div>' +
        '<h3>Request received.</h3>' +
        '<p>We’ll come back to you within one working day — usually sooner.</p>' +
        '<p class="success__next"><b>Don’t want to wait?</b></p>' +
        '<a class="btn btn--fill" href="/pages/business#enquire">Book a discovery call</a>';
      form.replaceWith(box);
    }
  });

  /* ---- Resource Hub: loading state --------------------------------------
     Skeletons on first paint, so the wait has a shape. Real data would swap
     these for results; here it is a short delay to make the state visible. */
  var resSkelHost = document.getElementById('rpanel');
  if (resSkelHost && !params.has('noskel')) {
    var real = resSkelHost.innerHTML;
    var skel = '';
    for (var i = 0; i < 6; i++) {
      skel += '<div class="skelcard"><span class="skel skel--line skel--short"></span>' +
              '<span class="skel skel--line"></span><span class="skel skel--line skel--short"></span></div>';
    }
    resSkelHost.innerHTML = skel;
    resSkelHost.setAttribute('aria-busy', 'true');
    setTimeout(function () {
      resSkelHost.innerHTML = real;
      resSkelHost.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('res:loaded'));
    }, 700);
  }

  /* ---- Mobile navigation ------------------------------------------------
     Built from the existing nav rather than duplicated in markup: one
     implementation across every page, and the mobile and desktop menus can't
     drift apart when a nav item changes.

     Dropdowns become flat labelled groups. Hover menus don't work on touch,
     and a nested accordion inside a drawer is two taps to reach a link that
     could have been one. */
  document.querySelectorAll('.site-nav').forEach(function (nav) {
    var inner = nav.querySelector('.site-nav__inner');
    var links = nav.querySelector('.site-nav__links');
    var right = nav.querySelector('.site-nav__right');
    if (!inner || !links || nav.querySelector('.nav-toggle')) return;

    /* Keep the basket (consumer) and the primary CTA (business) on the bar. */
    if (right) {
      var btn = right.querySelector('.btn');
      if (btn) btn.classList.add('nav-keep');
      var basket = right.querySelector('.nav-basket');
      if (basket) basket.classList.add('nav-keep');
    }

    var drawer = document.createElement('div');
    drawer.className = 'nav-drawer';
    drawer.hidden = true;
    var list = document.createElement('div');
    list.className = 'nav-drawer__inner';
    drawer.appendChild(list);

    function addLink(href, text, sub) {
      var a = document.createElement('a');
      a.href = href || '#';
      a.textContent = text;
      if (sub) a.className = 'is-sub';
      list.appendChild(a);
    }
    function addGroup(text) {
      var g = document.createElement('div');
      g.className = 'nav-drawer__group';
      g.textContent = text;
      list.appendChild(g);
    }

    Array.prototype.forEach.call(links.children, function (child) {
      if (child.classList.contains('has-menu')) {
        var trigger = child.querySelector(':scope > a');
        if (trigger) addLink(trigger.getAttribute('href'), trigger.textContent.replace('▾', '').trim());
        child.querySelectorAll('.nav-menu > *').forEach(function (item) {
          if (item.classList.contains('is-head')) addGroup(item.textContent);
          else if (item.tagName === 'A') addLink(item.getAttribute('href'), item.textContent, true);
        });
      } else if (child.tagName === 'A') {
        addLink(child.getAttribute('href'), child.textContent);
      }
    });

    /* Utility row: everything the bar dropped, as chips rather than rows. */
    if (right) {
      var util = document.createElement('div');
      util.className = 'nav-drawer__util';
      var any = false;
      Array.prototype.forEach.call(right.children, function (el) {
        if (el.classList.contains('nav-keep')) return;
        var a = document.createElement('a');
        a.href = el.tagName === 'A' ? el.getAttribute('href') : '#';
        a.textContent = el.textContent.trim();
        util.appendChild(a);
        any = true;
      });
      if (any) {
        var sep = document.createElement('div');
        sep.className = 'nav-drawer__sep';
        list.appendChild(sep);
        drawer.appendChild(util);
      }
    }

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'nav-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Menu');
    toggle.innerHTML = '<span></span><span></span><span></span>';

    inner.appendChild(toggle);
    nav.appendChild(drawer);

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', String(open));
      drawer.hidden = !open;
      /* Lock the page behind the drawer, or scrolling the menu scrolls the
         article underneath it — the classic mobile-menu bug. */
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      if (nav.contains(e.target)) return;
      setOpen(false);
    });

    /* Returning to desktop with the drawer open would leave the page locked. */
    var mq = matchMedia('(min-width: 861px)');
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function (ev) {
      if (ev.matches) setOpen(false);
    });
  });

  /* ---- Shared-page navigation ------------------------------------------
     Our Story and the Resource Hub are one URL for both audiences, so the
     header follows the visitor rather than the page. Both navs are in the DOM
     here and one is hidden — fine for a prototype, but the real build must
     render one server-side, or a business visitor's markup still contains a
     basket and a consumer nav for crawlers and screen readers to find. */
  var navBtn = document.getElementById('t-navmode');
  if (navBtn) {
    var biz = localStorage.getItem('wf-navmode') === 'business';
    applyNav(biz);
    navBtn.addEventListener('click', function () {
      biz = !biz;
      localStorage.setItem('wf-navmode', biz ? 'business' : 'personal');
      applyNav(biz);
    });
  }
  function applyNav(isBiz) {
    document.body.classList.toggle('nav-business', isBiz);
    document.querySelectorAll('[data-nav]').forEach(function (n) {
      n.hidden = (n.getAttribute('data-nav') === 'business') !== isBiz;
    });
    if (navBtn) {
      navBtn.textContent = 'Nav: ' + (isBiz ? 'business' : 'personal');
      navBtn.setAttribute('aria-pressed', String(isBiz));
    }
  }

  /* ---- Product type switch ---------------------------------------------
     One template, three types. Only the genuinely different blocks swap. */
  var PTYPES = {
    bike: {
      crumb: 'E-bikes', name: 'SX-250', title: 'SX-250 — Pedal assist',
      sub: 'No licence needed. EAPC compliant.', price: '£2,495.00',
      related: 'Goes with the SX-250'
    },
    accessory: {
      crumb: 'Accessories', name: 'Top box', title: 'Top box — 30L',
      sub: 'Lockable, fits the rear rack.', price: '£00.00',
      related: 'Often bought together'
    },
    service: {
      crumb: 'Services', name: 'Maintenance', title: 'Maintenance package',
      sub: 'Annual service, collection and return included.', price: '£00.00',
      related: 'Other services'
    }
  };
  var ptypeSel = document.getElementById('t-ptype');
  if (ptypeSel) {
    var pt = params.get('type') || localStorage.getItem('wf-ptype') || 'bike';
    ptypeSel.value = pt;
    applyPtype(pt);
    ptypeSel.addEventListener('change', function () {
      localStorage.setItem('wf-ptype', ptypeSel.value);
      applyPtype(ptypeSel.value);
    });
  }
  function applyPtype(type) {
    var d = PTYPES[type];
    if (!d) return;
    var set = function (sel, txt) {
      var el = document.querySelector(sel);
      if (el) el.textContent = txt;
    };
    set('[data-ptype-label]', d.crumb);
    set('[data-ptype-name]', d.name);
    set('[data-ptype-title]', d.title);
    set('[data-ptype-sub]', d.sub);
    set('[data-ptype-price]', d.price);
    set('[data-ptype-related]', d.related);

    document.querySelectorAll('[data-bike-only]').forEach(function (el) { el.hidden = type !== 'bike'; });
    document.querySelectorAll('[data-accessory-only]').forEach(function (el) { el.hidden = type !== 'accessory'; });
    document.querySelectorAll('[data-service-only]').forEach(function (el) { el.hidden = type !== 'service'; });
    /* Services ship nothing, so delivery and returns lines don't apply. */
    document.querySelectorAll('[data-not-service]').forEach(function (el) { el.hidden = type === 'service'; });

    /* Move the detail tabs onto a panel that still exists for this type. */
    var firstTab = document.querySelector('[data-ptab]:not([hidden])');
    if (firstTab) firstTab.click();
  }

  /* ---- Product detail tabs (same pattern as the shop) ------------------- */
  var ptabs = Array.prototype.slice.call(document.querySelectorAll('[data-ptab]'));
  if (ptabs.length) {
    ptabs.forEach(function (t) {
      t.addEventListener('click', function () {
        ptabs.forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-selected', String(on));
          o.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(o.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  /* ---- Resource Hub: tabs + filters combine ----------------------------
     The tab picks the KIND of thing; the chips narrow WHICH. They have to
     work together — forcing a reader to choose between "manuals" and "SX-250"
     when they want the SX-250 manual is the classic version of this mistake. */
  var resGrid = document.getElementById('rpanel');
  if (resGrid) {
    var state = { type: 'all', model: 'all', aud: 'all' };
    /* Queried fresh each render, not cached: the loading skeleton replaces the
       grid's innerHTML, and a cached list would hold detached nodes after the
       real results swap in. */
    var cards = function () {
      return Array.prototype.slice.call(resGrid.querySelectorAll('.rescard'));
    };
    var countEl = document.getElementById('res-count');
    var emptyEl = document.getElementById('res-empty');

    function matches(c) {
      var t = c.getAttribute('data-type');
      var m = c.getAttribute('data-model');
      var a = c.getAttribute('data-aud');
      if (state.type !== 'all' && t !== state.type) return false;
      /* "all" on a card means it applies to everything, so it always passes. */
      if (state.model !== 'all' && m !== state.model && m !== 'all') return false;
      if (state.aud !== 'all' && a !== state.aud && a !== 'all') return false;
      return true;
    }

    function render() {
      var n = 0;
      cards().forEach(function (c) {
        var ok = matches(c);
        c.hidden = !ok;
        if (ok) n++;
      });
      if (countEl) countEl.textContent = n;
      if (emptyEl) emptyEl.hidden = n !== 0;
      var dirty = state.type !== 'all' || state.model !== 'all' || state.aud !== 'all';
      document.querySelectorAll('#res-clear, #res-clear2').forEach(function (b) {
        if (b.id === 'res-clear') b.hidden = !dirty;
      });
    }

    document.querySelectorAll('[data-rtab]').forEach(function (t) {
      t.addEventListener('click', function () {
        state.type = t.getAttribute('data-rtab');
        document.querySelectorAll('[data-rtab]').forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-selected', String(on));
          o.tabIndex = on ? 0 : -1;
        });
        render();
      });
    });

    document.querySelectorAll('.chip').forEach(function (c) {
      c.addEventListener('click', function () {
        var group = c.getAttribute('data-filter');
        state[group] = c.getAttribute('data-value');
        document.querySelectorAll('.chip[data-filter="' + group + '"]').forEach(function (o) {
          o.classList.toggle('is-on', o === c);
        });
        render();
      });
    });

    document.querySelectorAll('#res-clear, #res-clear2').forEach(function (b) {
      b.addEventListener('click', function () {
        state = { type: 'all', model: 'all', aud: 'all' };
        document.querySelectorAll('[data-rtab]').forEach(function (o) {
          var on = o.getAttribute('data-rtab') === 'all';
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-selected', String(on));
        });
        document.querySelectorAll('.chip').forEach(function (o) {
          o.classList.toggle('is-on', o.getAttribute('data-value') === 'all');
        });
        render();
      });
    });

    /* Re-run once the loading skeleton has been replaced by real results. */
    document.addEventListener('res:loaded', render);
    render();
  }

  /* ---- Sector template --------------------------------------------------
     One template, eight sectors. Only five things genuinely differ per
     sector: headline, problem, recommended model, considerations, case study.
     If a sector can't fill those with something specific, it isn't a sector
     yet and shouldn't have a page. */
  var SECTORS = {
    food: {
      crumb: 'Food delivery', kicker: 'Food delivery',
      title: 'Thirty drops a night,<br>none of them worth a van.',
      lede: 'Restaurants, takeaways, groceries and newsagents running their own deliveries — where the round is short, frequent, and currently costing more in parking than in fuel.',
      probh: 'The vehicle is wrong for the job.',
      prob1: 'Short hops in a town centre, often at peak traffic, with a driver spending as long finding somewhere to stop as making the drop.',
      prob2: 'The bill is parking fines, congestion charges and driver hours — not fuel. And a second van at peak is rarely justifiable for thirty drops.',
      model: 'SX-250 — no licence required',
      why: 'Anyone on the payroll can ride it from day one: no CBT, no waiting, no restriction on who you can hire during a rush.',
      points: ['Cycle lanes bypass the traffic that delays the van', 'Top box carries a typical multi-drop load', 'Riders can be hired and riding the same week'],
      casekicker: 'Food delivery', casetitle: 'Pizza chain — 14 sites, riders on the road in a week',
      cta: 'Would this work for your round?'
    },
    pharmacy: {
      crumb: 'Pharmacy & medical', kicker: 'Pharmacy & medical',
      title: 'Prescriptions don\'t wait<br>for a parking space.',
      lede: 'Pharmacies, dispensaries and medical couriers making time-critical local deliveries where lateness is a clinical problem, not just a service one.',
      probh: 'Time-critical, low-value, high-frequency.',
      prob1: 'Individual drops are small and urgent. A van is idle most of the day and stuck the rest, and same-day promises fail on traffic rather than dispensing.',
      prob2: 'Many deliveries are to residential streets with no parking, so the driver is walking the last hundred metres anyway.',
      model: 'SX-250 — no licence required',
      why: 'Reaches addresses a van can\'t park near, and any dispensary assistant can ride it without a licence.',
      points: ['Lockable top box for controlled handover', 'Cycle access to pedestrianised areas', 'Predictable journey times regardless of traffic'],
      casekicker: 'Care & pharmacy', casetitle: 'Caremark — home care rounds in four territories',
      cta: 'Would this work for your dispensary?'
    },
    security: {
      crumb: 'Security & facilities', kicker: 'Security & facilities',
      title: 'Cover the whole site<br>without a patrol vehicle.',
      lede: 'Security teams, facilities contractors and site patrols covering large private estates, retail parks and industrial sites on foot or in a van.',
      probh: 'Too big to walk, too small to drive.',
      prob1: 'A patrol on foot is slow and covers a fraction of the site; a patrol vehicle can\'t reach half of it and costs more than the contract allows.',
      prob2: 'Response time is the contracted metric, and both options fail it in different ways.',
      model: 'SX-250 — no licence required',
      why: 'Goes where a vehicle can\'t, at four times walking pace, and any officer can ride it without a licence check.',
      points: ['Access to paths, service roads and pedestrian areas', 'Near-silent — useful on night patrol', 'Charges between shifts, no fuel card'],
      casekicker: 'Security & facilities', casetitle: 'Facilities contractor — patrol coverage across a retail park',
      cta: 'Would this work for your site?'
    },
    care: {
      crumb: 'Care providers', kicker: 'Care providers',
      title: 'Fifteen minutes between<br>visits, and no parking.',
      lede: 'Domiciliary care providers whose staff travel between client homes all day, in residential streets where parking is the hardest part of the round.',
      probh: 'The travel is the cost, not the care.',
      prob1: 'Carers spend a significant share of the working day driving and parking between short visits, often reimbursed per mile.',
      prob2: 'Recruitment is harder when a driving licence and a car are effectively required for the job.',
      model: 'SX-250 — no licence required',
      why: 'Removes the licence requirement from the role entirely, which widens the pool of people who can do the job.',
      points: ['Widens recruitment — no licence or car needed', 'Parks directly outside the client\'s home', 'Predictable round times in residential areas'],
      casekicker: 'Care & pharmacy', casetitle: 'Caremark — home care rounds in four territories',
      cta: 'Would this work for your rounds?'
    },
    council: {
      crumb: 'Local authority', kicker: 'Local authority',
      title: 'Parks, wardens<br>and everything between.',
      lede: 'Councils and public bodies moving staff around parks, town centres and estates — where a van is overkill and walking is too slow.',
      probh: 'Public sites, private budgets.',
      prob1: 'Grounds teams, wardens and enforcement officers cover large areas with no practical vehicle access and tight operating budgets.',
      prob2: 'Emissions and air quality commitments make adding vehicles politically difficult even when they\'d help.',
      model: 'SX-250 — no licence required',
      why: 'Zero emissions at point of use, no licence requirement for staff, and access to paths a vehicle can\'t use.',
      points: ['Supports air quality and net zero commitments', 'Procurement-friendly: leased as an operating cost', 'No licence check needed for seasonal staff'],
      casekicker: 'Local authority', casetitle: 'Council — parks team coverage without adding vehicles',
      cta: 'Would this work for your teams?'
    },
    rental: {
      crumb: 'Rental & subscription', kicker: 'Rental & subscription',
      title: 'You supply the riders.<br>We supply the bikes.',
      lede: 'Rental and subscription operators putting machines under delivery riders — where fleet uptime is the product, not a supporting service.',
      probh: 'Downtime is lost revenue, daily.',
      prob1: 'A bike off the road isn\'t an inconvenience, it\'s a subscription that isn\'t billing and a rider who may not come back.',
      prob2: 'Mixed fleets from multiple suppliers make spares, servicing and rider familiarity harder than they need to be.',
      model: 'SX-250 — no licence needed by any rider',
      why: 'Every rider can start immediately, whatever their licence status — which is what makes a rider base scalable rather than pre-screened.',
      points: ['Swap-out cover keeps subscriptions billing', 'Standardised fleet simplifies spares and training', 'Volume terms available above — bikes'],
      casekicker: 'Food delivery', casetitle: 'Delivery platform — rider supply without rider churn',
      cta: 'Would this work for your rider base?'
    },
    leisure: {
      crumb: 'Holiday parks & leisure', kicker: 'Holiday parks & leisure',
      title: 'Two hundred acres,<br>and staff crossing all of it.',
      lede: 'Holiday parks, campsites and leisure sites moving staff, and in some cases guests, across sites too large to walk and too enclosed to drive.',
      probh: 'A site, not a road network.',
      prob1: 'Maintenance, housekeeping and reception staff cross the site constantly. Buggies are slow, expensive and limited; walking wastes hours a day.',
      prob2: 'Headcount peaks seasonally, so anything requiring a licence check or training week doesn\'t work for a summer intake.',
      model: 'SX-250 — no licence required',
      why: 'Seasonal staff can ride from their first shift with no licence check, and the machine works on paths a buggy can\'t use.',
      points: ['Seasonal staff riding from day one', 'Quiet enough for early and late shifts', 'Optional guest hire as a revenue line'],
      casekicker: 'Holiday parks & leisure', casetitle: 'Haven — 18 bikes across nine parks',
      cta: 'Would this work across your site?'
    },
    campus: {
      crumb: 'Hotels & campuses', kicker: 'Hotels & campuses',
      title: 'Large sites, small journeys,<br>constant movement.',
      lede: 'Hotels, universities, hospitals and business parks where grounds, maintenance and security staff cover the same ground all day.',
      probh: 'Everything is five minutes away, forty times a day.',
      prob1: 'Individually trivial journeys add up to hours of staff time, and a vehicle is impractical on a site built around pedestrians.',
      prob2: 'Guests, patients and students share the space, so anything fast or loud is unacceptable.',
      model: 'SX-250 — no licence required',
      why: 'Quiet, pedestrian-compatible, and rideable by any staff member without a licence or a training backlog.',
      points: ['Shares space safely with pedestrians', 'No licence check for new or agency staff', 'Charges overnight on standard sockets'],
      casekicker: 'Hotels & campuses', casetitle: 'Campus — grounds team coverage without vehicles',
      cta: 'Would this work on your site?'
    }
  };

  var secSel = document.getElementById('t-sector');
  if (secSel) {
    var s0 = params.get('s') || localStorage.getItem('wf-sector') || 'food';
    if (!SECTORS[s0]) s0 = 'food';
    secSel.value = s0;
    applySector(s0);
    secSel.addEventListener('change', function () {
      localStorage.setItem('wf-sector', secSel.value);
      applySector(secSel.value);
    });
  }
  function applySector(key) {
    var d = SECTORS[key];
    if (!d) return;
    var put = function (sel, val, html) {
      var el = document.querySelector(sel);
      if (!el) return;
      if (html) el.innerHTML = val; else el.textContent = val;
    };
    put('[data-sec-crumb]', d.crumb);
    put('[data-sec-kicker]', d.kicker);
    put('[data-sec-title]', d.title, true);
    put('[data-sec-lede]', d.lede);
    put('[data-sec-probh]', d.probh);
    put('[data-sec-prob1]', d.prob1);
    put('[data-sec-prob2]', d.prob2);
    put('[data-sec-model]', d.model);
    put('[data-sec-why]', d.why);
    put('[data-sec-casekicker]', d.casekicker);
    put('[data-sec-casetitle]', d.casetitle);
    put('[data-sec-cta]', d.cta);
    var pts = document.querySelector('[data-sec-points]');
    if (pts) pts.innerHTML = d.points.map(function (p) { return '<li>' + p + '</li>'; }).join('');
    document.title = d.crumb + ' — wireframe (/fleet-solutions/sectors/…)';
  }

  /* ---- Case study sector filter ----------------------------------------
     Sector is the only filter that matters here: a holiday park manager
     self-identifies by sector, not by fleet size. */
  var caseGrid = document.getElementById('case-grid');
  if (caseGrid) {
    var caseCards = Array.prototype.slice.call(caseGrid.querySelectorAll('.cscard'));
    var caseEmpty = document.getElementById('cs-empty');

    function filterCases(sector) {
      var n = 0;
      caseCards.forEach(function (c) {
        var ok = sector === 'all' || c.getAttribute('data-sector') === sector;
        c.hidden = !ok;
        if (ok) n++;
      });
      if (caseEmpty) caseEmpty.hidden = n !== 0;
    }

    document.querySelectorAll('[data-sector]').forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      b.addEventListener('click', function () {
        document.querySelectorAll('.csfilter').forEach(function (o) { o.classList.toggle('is-on', o === b); });
        filterCases(b.getAttribute('data-sector'));
      });
    });

    var csClear = document.getElementById('cs-clear');
    if (csClear) csClear.addEventListener('click', function () {
      document.querySelectorAll('.csfilter').forEach(function (o) {
        o.classList.toggle('is-on', o.getAttribute('data-sector') === 'all');
      });
      filterCases('all');
    });

    /* Deep link: /case-studies?sector=care arrives pre-filtered, so the sector
       tiles on /business can hand a reader straight to the proof for their own
       industry instead of a general index. An unknown sector still filters —
       it just filters to nothing and the empty state explains why, which is the
       honest answer for a sector with no study written yet. */
    var wanted = new URLSearchParams(location.search).get('sector');
    if (wanted) {
      var matched = false;
      document.querySelectorAll('.csfilter').forEach(function (o) {
        var on = o.getAttribute('data-sector') === wanted;
        if (on) matched = true;
        o.classList.toggle('is-on', on);
      });
      /* No chip for this sector: drop the "All" highlight rather than leaving a
         filter lit that doesn't describe what's on screen. */
      if (!matched) {
        document.querySelectorAll('.csfilter').forEach(function (o) { o.classList.remove('is-on'); });
      }
      filterCases(wanted);
    }
  }

  /* ---- Colour swatches on the product page ------------------------------ */
  /* ---- Product gallery: variant x colour x angle -------------------------
     Three controls over one image set. The rules that matter:

     - Coverage is uneven. All 40 variant/colour combinations have a front view;
       only 16 have all three angles, and Tourer has a side view in exactly one
       colour. So the angle strip is BUILT from the manifest every time, never
       hard-coded, and a missing angle simply does not appear.
     - The chosen angle is kept across changes when it still exists, and falls
       back to front when it does not — switching to Tourer should not strand
       you on a rear view that was never shot.
     - Nothing here needs to align the images: every file in assets/bikes is
       already pinned on the front tyre by _build-bikes.py. */
  var gallery = document.getElementById('pdp-main');
  if (gallery) {
    var manifestEl = document.getElementById('bike-manifest');
    var BIKES = manifestEl ? JSON.parse(manifestEl.textContent) : {};
    var thumbs = document.getElementById('pdp-thumbs');
    var variantSel = document.getElementById('pdp-variant');
    var colourName = document.getElementById('pdp-colour-name');
    /* 'detail' is the colour-matched pod on the Tourer. It is a close crop
       rather than a whole-bike view, so it is deliberately last: the three
       bike angles read as a set and this one is a different kind of shot. */
    var ANGLE_LABEL = { front: 'Front', side: 'Side', rear: 'Rear', detail: 'Pod' };
    var state = { variant: 'classic', colour: 'gloss-grey', angle: 'front' };

    /* What each variant adds over a Classic. Kept beside the gallery because
       both are driven by the same select, and a second listener reading the
       same value is how the two drift apart.

       Dimensions come from the Technical Specification Guide; what is fitted to
       each variant comes from the client. Note the Guide attributes the
       indicators and brake light to the CARRIER and the client attributes them
       to the BOX — the wording here follows the client and avoids splitting
       them, so do not "correct" it back against the Guide. */
    var INCLUDES = {
      'classic': [
        ['Nothing else &mdash; the Classic is the SX-250 as standard.', false],
        ['A rear carrier and a pod can be added later; the mounting points are already there.', true]
      ],
      'explorer': [
        ['52-litre lockable pod on a rear carrier', false]
      ],
      'tourer': [
        ['22-litre pod on a rear carrier, colour-matched to the bike', false],
        ['Integrated rear light lens, and a lock barrel on the base', false],
        ['Confirm whether a key for the pod is supplied with the bike', true]
      ],
      'cargo': [
        ['108-litre cargo box with indicators and brake light built in &mdash; 54 &times; 53 &times; 39&nbsp;cm', false],
        ['Twinflute 4&nbsp;mm / 585&nbsp;gsm board, steel plate fixings, side-release strap', false],
        ['Rear sliding carrier &mdash; 51 &times; 48 &times; 10&nbsp;cm, aluminium, spring-and-lock', false]
      ]
    };
    /* Price by variant, with the matching monthly at the same 10% deposit over
       12 months. Both are stated, not one derived from the other at runtime —
       the monthly rounds UP to the penny under Payl8r's convention, and a
       divide-by-twelve in the browser would quietly disagree with the figures
       generated by _rep-example.py and published in the footer.
       Regenerate with: python _rep-example.py <price> <deposit>  */
    var PRICES = window.ESKUTA_PRICES || {
      'classic':         { cash: '£2,495.00', monthly: '£187.13' },
      'tourer':          { cash: '£2,595.00', monthly: '£194.63' },
      'explorer':        { cash: '£2,695.00', monthly: '£202.13' },
      'cargo':           { cash: '£2,695.00', monthly: '£202.13' }
    };
    var cashEl = document.querySelector('[data-ptype-price]');
    var finEl = document.querySelector('.pdp__fin');

    function renderPrice() {
      var p = PRICES[state.variant];
      if (!p || !cashEl) return;
      if (p.cash) {
        cashEl.textContent = p.cash;
        cashEl.removeAttribute('data-verify');
        if (finEl) finEl.innerHTML = 'or ' + p.monthly + '/mo over 12 months';
      } else {
        /* Not priced yet. Saying nothing is better than showing the Classic's
           price against a variant that costs more. */
        cashEl.textContent = 'Price to confirm';
        cashEl.setAttribute('data-verify', '');
        if (finEl) finEl.innerHTML = 'Finance available &mdash; figures once the price is set';
      }
    }

    var inclList = document.getElementById('incl-variant-list');
    var inclName = document.getElementById('incl-variant');

    function renderIncludes() {
      if (!inclList) return;
      inclList.innerHTML = '';
      (INCLUDES[state.variant] || []).forEach(function (row) {
        var li = document.createElement('li');
        li.innerHTML = row[0];
        if (row[1]) li.setAttribute('data-verify', '');
        inclList.appendChild(li);
      });
      if (inclName) inclName.textContent = pretty(state.variant);
    }

    function pretty(slug) {
      return slug.split('-').map(function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      }).join(' ');
    }
    function media(v, c, a) {
      return (window.ESKUTA_MEDIA || {})[v + '|' + c + '|' + a] || null;
    }
    /* Detail shots are the same for every trim and colour, so they are
       addressed as angle 'detail:<n>' rather than by a variant key. */
    function detailAt(a) {
      if (!a || a.indexOf('detail:') !== 0) return null;
      return (window.ESKUTA_DETAILS || [])[parseInt(a.slice(7), 10)] || null;
    }
    function file(v, c, a) {
      var d = detailAt(a);
      if (d) return d.src;
      var m = media(v, c, a);
      return m ? m.src : eskutaAsset('sx250-' + v + '-' + c + '-' + a + '.webp');
    }
    function thumbFile(v, c, a) {
      var d = detailAt(a);
      if (d) return d.thumb;
      var m = media(v, c, a);
      return m ? m.thumb : eskutaAsset('sx250-' + v + '-' + c + '-' + a + '.webp');
    }
    function angles() { return ((BIKES[state.variant] || {})[state.colour]) || ['front']; }

    /* The heading carries the selected kit. Changing trim re-renders the
       gallery and the price without a reload, so without this the title would
       still name the trim the page was opened on. data-base-title holds the
       product name as Shopify wrote it, so this never appends to its own
       output and end up with "SX-250 - Cargo - Tourer". */
    /* What this kit gets you, under the buy button. Same facts as INCLUDES
       above -- that list is the detail further down the page, this is the one
       line someone reads with their finger over Add to basket. Keyed by the
       trim slug so it follows the swatches without a reload. */
    /* Every kit's pane is already in the page, rendered by Liquid. Switching is
       a class toggle, not a rebuild -- which is why the height cannot change:
       all four panes stay in the grid and the tallest holds the space open. */
    var kitPanes = document.querySelectorAll('.pdp__kit-pane');
    function renderKitNote() {
      var want = pretty(state.variant);
      kitPanes.forEach(function (pane) {
        pane.classList.toggle('is-off', pane.getAttribute('data-kit') !== want);
      });
    }

    var titleEl = document.querySelector('[data-pdp-title]');
    function renderTitle() {
      if (!titleEl) return;
      var base = titleEl.getAttribute('data-base-title') || '';
      var trim = pretty(state.variant);
      titleEl.innerHTML = base
        ? base + (trim ? ' \u2013 <span class="pdp__trim">' + trim + '</span>' : '')
        : titleEl.innerHTML;
    }

    function render() {
      var list = angles();
      if (list.indexOf(state.angle) === -1 && !detailAt(state.angle)) state.angle = list[0];
      gallery.src = file(state.variant, state.colour, state.angle);
      var shown = detailAt(state.angle);
      gallery.alt = shown ? shown.alt
        : 'Eskuta SX-250 ' + pretty(state.variant) + ' in ' + pretty(state.colour);
      if (colourName) colourName.textContent = pretty(state.colour);

      renderIncludes();
      renderPrice();
      renderTitle();
      renderKitNote();

      thumbs.innerHTML = '';
      list.forEach(function (a) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp__thumb' + (a === state.angle ? ' is-on' : '');
        b.setAttribute('aria-pressed', String(a === state.angle));
        b.setAttribute('aria-label', ANGLE_LABEL[a] + ' view');
        var i = document.createElement('img');
        i.src = thumbFile(state.variant, state.colour, a);
        i.alt = '';
        i.loading = 'lazy';
        b.appendChild(i);
        b.addEventListener('click', function () { state.angle = a; render(); });
        thumbs.appendChild(b);
      });

      (window.ESKUTA_DETAILS || []).forEach(function (d, idx) {
        var key = 'detail:' + idx;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp__thumb' + (state.angle === key ? ' is-on' : '');
        b.setAttribute('aria-pressed', String(state.angle === key));
        b.setAttribute('aria-label', d.alt || 'Detail view');
        var i = document.createElement('img');
        i.src = d.thumb;
        i.alt = '';
        i.loading = 'lazy';
        b.appendChild(i);
        b.addEventListener('click', function () { state.angle = key; render(); });
        thumbs.appendChild(b);
      });
    }

    document.querySelectorAll('#pdp-swatches [data-colour]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.colour = btn.getAttribute('data-colour');
        document.querySelectorAll('#pdp-swatches [data-colour]').forEach(function (o) {
          var on = o === btn;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-pressed', String(on));
        });
        render();
      });
    });
    if (variantSel) {
      variantSel.addEventListener('change', function () {
        state.variant = variantSel.value;
        render();
      });
    }
    /* Shopify renders the selected variant server-side, so the opening
       state comes from the DOM. Left at the wireframe's hard-coded
       default, landing on ?variant=<a tourer> shows Tourer in the select
       and a Classic in the gallery. */
    if (variantSel && variantSel.value) state.variant = variantSel.value;
    var onSwatch = document.querySelector('#pdp-swatches [data-colour][aria-pressed="true"]');
    if (onSwatch) state.colour = onSwatch.getAttribute('data-colour');
    render();
  }

  /* ---- Shop category tabs ----------------------------------------------
     Full ARIA tabs pattern: roving tabindex so only the active tab is in the
     tab order, arrow keys to move between them, Home/End to the ends. That
     keyboard behaviour is the part most tab implementations skip.

     The two cross-sell shelves below are marked data-ebikes-only, because on
     the Accessories tab they would just duplicate the grid above. */
  var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-tab]'));
  if (tabs.length) {
    var panels = {
      ebikes: document.getElementById('panel-ebikes'),
      accessories: document.getElementById('panel-accessories'),
      apparel: document.getElementById('panel-apparel')
    };
    var crossSell = document.querySelectorAll('[data-ebikes-only]');

    function selectTab(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === name;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      Object.keys(panels).forEach(function (k) {
        if (panels[k]) panels[k].hidden = k !== name;
      });
      crossSell.forEach(function (s) { s.hidden = name !== 'ebikes'; });

      /* Linkable without adding a history entry per click. */
      var u = new URL(location.href);
      u.searchParams.set('tab', name);
      history.replaceState(null, '', u);
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { selectTab(t.getAttribute('data-tab')); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t), next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        selectTab(next.getAttribute('data-tab'), true);
      });
    });

    var startTab = params.get('tab');
    if (startTab && panels[startTab]) selectTab(startTab);
  }

  /* ---- Fleet-size switch (leasing) --------------------------------------
     Selection only. The handler this replaces looked each button up in a
     price table keyed by MODEL name — so on the one page that actually renders
     a .fin__switch, "5-10 bikes" never matched and the control did nothing at
     all. The figures beside it are still £— pending the leasing rates, so there
     is nothing to swap in yet; until there is, the least this can do is show
     which option is selected. */
  document.querySelectorAll('.fin__switch').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn || !group.contains(btn)) return;
      group.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-on', b === btn);
        b.setAttribute('aria-pressed', String(b === btn));
      });
    });
  });

  /* ---- Logo marquee ----------------------------------------------------
     The track is duplicated in JS rather than in markup, so the loop can never
     drift out of sync with the list — and a logo only has to be added once.
     Duplicate first, then resolve images, so clones get the same treatment
     without needing ids (which would collide once cloned). */
  document.querySelectorAll('[data-marquee]').forEach(function (m) {
    var track = m.querySelector('.marquee__track');
    if (!track) return;

    track.innerHTML += track.innerHTML;   /* two passes = seamless -50% loop */

    track.querySelectorAll('[data-logo]').forEach(function (img) {
      var item = img.closest('.marquee__item');
      img.addEventListener('load', function () {
        img.classList.add('is-loaded');
        if (item) item.classList.add('is-loaded');
      });
      img.src = eskutaAsset(img.getAttribute('data-logo') + '.png');
    });

    /* Duplicated logos are decorative — hide the repeat from screen readers.
       Now that the items are links, aria-hidden alone isn't enough: an
       aria-hidden element that is still focusable is an accessibility failure
       (the user tabs to a control the screen reader refuses to announce). The
       clones need taking out of the tab order too. */
    var children = track.children;
    for (var i = children.length / 2; i < children.length; i++) {
      children[i].setAttribute('aria-hidden', 'true');
      if (children[i].tagName === 'A') children[i].setAttribute('tabindex', '-1');
    }
  });

  /* ---- Logo tiles outside the marquee ----------------------------------
     The rider platform router. Same load-gated contract: the mark only
     appears on a successful load, so a platform we don't hold a logo for
     keeps its name in text rather than showing a broken image. Adding one
     later is a file drop into assets/logos/ with no markup change. */
  document.querySelectorAll('.logo-tile__img[data-logo]').forEach(function (img) {
    var tile = img.closest('.logo-tile');
    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
      if (tile) tile.classList.add('is-loaded');
    });
    img.src = eskutaAsset(img.getAttribute('data-logo') + '.png');
  });

  /* "Clicking Personal does the same as scrolling" — the primary door is an
     in-page anchor, so this just makes the intent explicit for the prototype. */
  var personal = document.querySelector('[data-door="personal"]');
  if (personal) {
    personal.addEventListener('click', function (e) {
      e.preventDefault();
      var nav = document.querySelector('.site-nav');
      if (!nav) return;
      /* Same landing point as the fold snap, so clicking and scrolling agree.
         Targeting #shop instead would stop 62px lower and the two would
         disagree by exactly the height of the nav. */
      window.scrollTo({
        top: window.scrollY + nav.getBoundingClientRect().top - 52,
        behavior: 'smooth'
      });
    });
  }

  /* ---- Enquiry forms, without the round trip ---------------------------
     A Shopify contact form POSTs and redirects, so the page reloads, lands at
     the top, and the anchor drops the reader back at the bottom. For a form
     rejected over one empty field that is a lot of movement to say very little.

     Bound to .frm--enquiry only -- the business enquiry and the contact page,
     which are generated from the same block. The product form is left alone.

     Everything here is an enhancement over a form that already works: if fetch
     is missing, or the request fails, the browser's own submission still runs. */
  /* Google Ads lead conversion.

     With a native submit there is no success callback to hang this on -- the
     page reloads and Shopify renders the thank-you. So it fires when that
     thank-you is on the page, which is the "conversion page" pattern the Ads
     snippet was written for in the first place. It cannot fire on an ordinary
     visit, because .frm__ok--sent only exists after a successful post. */
  (function () {
    if (!document.querySelector('.frm__ok--sent')) return;
    if (typeof gtag !== 'function') return;
    gtag('event', 'conversion', {
      send_to: 'AW-17916593342/xLlbCN289ZocEL6Jpt9C',
      value: 1.0,
      currency: 'GBP'
    });
  }());

  document.querySelectorAll('form.frm--enquiry').forEach(function (form) {
    /* This form submits NATIVELY, and that is deliberate.

       Two things rule out anything cleverer. Shopify protects it with hCaptcha,
       which only attaches its token to a native submit -- a fetch goes without
       one and is rejected with "Missing CAPTCHA token". And the response to the
       submit carries frame-blocking headers, so aiming it at a hidden iframe
       fails with a Chrome network error and the reply can never be read.

       So the page does reload. Shopify redirects straight back here with
       ?contact_posted=true and the template renders the thank-you in place of
       the form, at the same position on the page. What is kept below is the
       client-side check, so an empty or malformed email is caught before any
       round trip and shown inline without leaving the page at all. */
    var btn = form.querySelector('button[type="submit"]');

    function clearErrors() {
      form.querySelectorAll('.fld.is-error').forEach(function (fld) {
        fld.classList.remove('is-error');
        var m = fld.querySelector('.fld__err');
        if (m) m.remove();
        var inp = fld.querySelector('input, select, textarea');
        if (inp) inp.removeAttribute('aria-invalid');
      });
      var box = form.querySelector('.frm__err');
      if (box) box.remove();
    }

    function markField(input, msg) {
      var fld = input.closest ? input.closest('.fld') : null;
      if (!fld) return;
      fld.classList.add('is-error');
      input.setAttribute('aria-invalid', 'true');
      if (!fld.querySelector('.fld__err')) {
        var s = document.createElement('span');
        s.className = 'fld__err';
        s.textContent = msg;
        fld.appendChild(s);
      }
    }

    function summary(html) {
      var d = document.createElement('div');
      d.className = 'frm__err';
      d.setAttribute('role', 'alert');
      d.innerHTML = html;
      form.insertBefore(d, form.firstChild);
      return d;
    }

    form.addEventListener('submit', function (e) {
      clearErrors();

      /* The browser already knows which field is wrong and why. Ask it first,
         so an empty email never costs a request or a page load. */
      var bad = form.querySelector(':invalid');
      if (bad) {
        e.preventDefault();
        markField(bad, bad.validity && bad.validity.valueMissing
          ? 'This one is needed.'
          : 'Check this and try again.');
        summary('<b>We could not send that.</b>' +
                'Check the highlighted field — nothing you typed has been lost.');
        if (bad.focus) bad.focus();
        return;
      }

      /* Valid: hand over to the native submit so hCaptcha can attach its token.
         No preventDefault, no target, nothing intercepted. */
      form.classList.add('is-busy');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    });
  });

})();
